export function identitiesNewlyRaised(
  previous: Iterable<string>,
  next: Iterable<string>,
): string[] {
  const seen = new Set(previous);
  const added: string[] = [];
  for (const identity of next) {
    if (!seen.has(identity)) added.push(identity);
  }
  return added;
}

type ChimeContext = {
  state: string;
  currentTime: number;
  resume: () => Promise<void>;
  createOscillator: () => OscillatorNode;
  createGain: () => GainNode;
  destination: AudioDestinationNode;
};

let sharedContext: AudioContext | null = null;

export function resetRaiseHandChimeContext() {
  sharedContext = null;
}

function getSharedContext(): AudioContext | null {
  if (typeof window === 'undefined' || typeof AudioContext === 'undefined') return null;
  sharedContext ??= new AudioContext();
  return sharedContext;
}

async function withReadyContext(
  context: ChimeContext | AudioContext | null,
  play: (ready: ChimeContext | AudioContext) => void,
): Promise<void> {
  if (!context) return;
  if (context.state === 'suspended') {
    try {
      await context.resume();
    } catch {
      return;
    }
  }
  play(context);
}

export async function playRaiseHandChime(
  context: ChimeContext | AudioContext | null = getSharedContext(),
): Promise<void> {
  await withReadyContext(context, (ready) => {
    const now = ready.currentTime;
    const oscillator = ready.createOscillator();
    const gain = ready.createGain();
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(880, now);
    oscillator.frequency.exponentialRampToValueAtTime(1318.5, now + 0.07);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.09, now + 0.012);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.22);
    oscillator.connect(gain);
    gain.connect(ready.destination);
    oscillator.start(now);
    oscillator.stop(now + 0.24);
  });
}

export async function playChatPop(
  context: ChimeContext | AudioContext | null = getSharedContext(),
): Promise<void> {
  await withReadyContext(context, (ready) => {
    const now = ready.currentTime;
    const oscillator = ready.createOscillator();
    const gain = ready.createGain();
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(784, now);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.045, now + 0.008);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.14);
    oscillator.connect(gain);
    gain.connect(ready.destination);
    oscillator.start(now);
    oscillator.stop(now + 0.15);
  });
}
